import { DOCUMENT_AUTOMATED_ONLY_KEY, DOCUMENT_FAVOURITES_ONLY_KEY } from 'constants/storage-keys'
import produce from 'immer'
import { Reducer } from 'redux'
import {
  SET_DOCUMENT_AUTOMATED_ONLY,
  SET_DOCUMENT_FAVOURITES_ONLY,
  SET_DOCUMENT_KEYWORD,
  SET_SELECTED_DOCUMENTS
} from 'redux/actions/types'
import { Document } from 'services/DocumentService'

interface PrecedentsState {
  keyword?: string
  showFavouritesOnly: boolean
  selectedDocuments: Document[]
  showAutomatedOnly: boolean
}

const initialShowFavouritesOnly: boolean = JSON.parse(localStorage.getItem(DOCUMENT_FAVOURITES_ONLY_KEY) ?? 'false')
const initialShowAutomatedOnly: boolean = JSON.parse(localStorage.getItem(DOCUMENT_AUTOMATED_ONLY_KEY) ?? 'false')

const initialState: PrecedentsState = {
  keyword: '',
  showFavouritesOnly: initialShowFavouritesOnly,
  selectedDocuments: [],
  showAutomatedOnly: initialShowAutomatedOnly
}
const precedents: Reducer<PrecedentsState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_DOCUMENTS:
      return produce(state, draft => {
        draft.selectedDocuments = action.selected
      })
    case SET_DOCUMENT_FAVOURITES_ONLY:
      return produce(state, draft => {
        draft.showFavouritesOnly = action.showFavouritesOnly
      })
    case SET_DOCUMENT_AUTOMATED_ONLY:
      return produce(state, draft => {
        draft.showAutomatedOnly = action.showAutomatedOnly
      })
    case SET_DOCUMENT_KEYWORD:
      return produce(state, draft => {
        draft.keyword = action.keyword
      })
    default:
      return state
  }
}

export default precedents
